import React from "react";
import "./App.css";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import SideNav from "./components/SideNav";
import ProblemSection from "./components/sections/ProblemSection";
import IndustryTicker from "./components/IndustryTicker";
import IndustriesSection from "./components/sections/IndustriesSection";
import OperationsSection from "./components/sections/OperationsSection";
import ClosingSections from "./components/sections/ClosingSections";
import StoriesSection from "./components/sections/StoriesSection";
import FinalSections from "./components/sections/FinalSections";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App bg-white text-[#0A0A0A] antialiased">
      <Toaster position="bottom-right" richColors />
      <Navbar />
      <SideNav />
      <main>
        <Hero />
        <IndustryTicker />
        <ProblemSection />
        <IndustriesSection />
        <OperationsSection />
        <ClosingSections />
        <StoriesSection />
        <FinalSections />
      </main>
      <Footer />
    </div>
  );
}

export default App;
